export default __webpack_public_path__ + "static/media/builder.1951aba0.jpg";